<template>
    <div>
        <div class="container">
            <div class="flex-center">
                <img :src="getIconStatus(result.status)" />
            </div>
            <div class="header-text flex-center line-register">
                {{ result.header }}
            </div>
            <div class="content-text flex-center line-register-text">
                {{ result.content }}
            </div>
            <div
                v-if="result.status === 'error'"
                class="flex-center back-btn">
                <v-btn
                    width="332"
                    height="40"
                    color="primary"
                    @click="goBack()">
                    สแกน QR Code
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import IconSuccess from '@/assets/icon/icon-success.png'
import IconError from '@/assets/icon/icon-error.png'
export default {
    name: 'LineRegisterResult',

    props: {
        result: {
            type: Object,
            default: null
        }
    },
    methods: {
        getIconStatus (status) {
            if (status === 'ok') {
                return IconSuccess
            } else {
                return IconError
            }
        },

        goBack () {
            this.$emit('getBack', false)
        }
    }
}
</script>

<style lang="scss" scoped>
    .container {
        background: #ffffff;
        border-top-right-radius: 15px;
        border-top-left-radius: 15px;
        padding: 10rem 1rem;
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 100vh;
        text-align: justify;
    }

    .header-text {
        font-size: 18px;
        color: #131410;
    }

    .content-text {
        font-size: 14px;
        color: #6c6c6c;
        padding: 0.5rem 4rem;
        text-align: center;
    }

    .flex-center {
        display: flex;
        justify-content: center;
    }

    .back-btn {
        padding: 1rem 0rem;
    }

    img {
        width: 60px
    }
    ::v-deep .v-btn__content {
        font-family: Prompt !important;
        font-size: 18px;
    }

</style>
